import React, { Component, Fragment } from 'react';

class Searchie extends Component {
  render() {
    const { visible } = this.props;
    if (!visible) {
      return null;
    }
    return <Fragment />;
  }

  componentDidMount() {
    this.addSearchieScript();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.handleVisibilityChange();
    }
  }

  addSearchieScript = () => {
    const searchie = document.getElementById('searchie-script');
    if (!searchie) {
      const script = document.createElement('script');
      script.id = 'searchie-script';
      script.src = 'https://app.searchie.io/js/js-popup.js?' + Date.now();
      script.async = true;
      script.onload = function () {
        if (window._searchie) {
          let searchieBtn = document.getElementById('searchie-fixed-btn');
          if (searchieBtn) searchieBtn.style.display = 'none';
        }
      }
      window._searchie = { widget: '9ZnpjXeDqX', url: 'https://app.searchie.io', user: undefined }
      const target = document.getElementsByTagName('script')[0];
      target.parentNode.insertBefore(script, target);
    }
  };

  handleVisibilityChange = () => {
    const { visible, onHide } = this.props;
    let searchieBtn = document.getElementById('searchie-fixed-btn');

    if (window._searchie) {
      window._searchie.toggle();
      if (searchieBtn) {
        if (visible) {
          searchieBtn.addEventListener('click', () => {
            if (onHide) {
              onHide();
            }
          });
        } else {
          window._searchie.toggle();
          searchieBtn.style.display = 'none';
        }
      }
    }
  };
}

export default Searchie;
